import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'XInputText',
  props: {
  type: {
    type: String,
    default: undefined
  }
},
  setup(__props) {

const props = __props





return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createBlock(_component_InputText, {
    type: props.type,
    required: "true",
    class: "p-inputtext x1s-input-font"
  }, null, 8, ["type"]))
}
}

})